import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { eventLogger } from '~/shared/services/eventLogger'
import { pinterestPixelService } from '~/shared/services/pinterestPixelService'
import { selectUserUUID } from '~/shared/store/user/selects'

export const useStartSession = (): void => {
  const dispatch = useDispatch()
  const uuid = useSelector(selectUserUUID)

  useEffect(() => {
    eventLogger.logSessionStarted()
    pinterestPixelService.trackPageVisit()
  }, [dispatch])

  useEffect(() => {
    if (uuid) {
      window.fbq('track', 'ViewContent', {}, { eventID: uuid })
    }
  }, [uuid])
}
